import { randomNumber } from '../../../utilities'
import { IntubationConstants } from './intubation.constants'
import { IIntubationState, IIntubationStateAction } from './intubation.types'

export const initialIntubationState: IIntubationState = {
  key: randomNumber().toString(),
  date: '',
  time: '',
  assessedBy: null,
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  size: '',
  distance: '',
  distanceUnit: null,
  method: null,
  securedVia: null,
  verifiedBy: null,
  verificationVia: [],
  airwayPlacementTechnique: [],
  airwayPlacementTechniquePNNV: null,
  rSIProtocol: null,
  mallampati: null,
  sellickManeuver: null,
  laryngoscopicGrade: null,
  styletUsed: null,
  cuffFill: null,
  indications: [],
  cuffFillQty: '',
  laryngoscopeBlade: null,
  decisiontoManageTime: '',
  decisiontoManageDate: '',
  decisiontoManageDateTime: '',
  abandonedTime: '',
  abandonedDate: '',
  abandonedDateTime: '',
  airwayComplications: [],
  airwayComplicationsPNNV: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  type: 'Intubation',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  intubationDefaults: null,
  nemsisCode: null,
  reasonsForFailure: [],
}

export function intubationReducer(
  state: IIntubationState = initialIntubationState,
  action: IIntubationStateAction
): IIntubationState {
  switch (action.type) {
    case IntubationConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case IntubationConstants.SET_DATE:
      return { ...state, date: action.date }
    case IntubationConstants.SET_TIME:
      return { ...state, time: action.time }
    case IntubationConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case IntubationConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case IntubationConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case IntubationConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case IntubationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case IntubationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case IntubationConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case IntubationConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case IntubationConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case IntubationConstants.SET_SIZE:
      return { ...state, size: action.size }
    case IntubationConstants.SET_DISTANCE:
      return { ...state, distance: action.distance }
    case IntubationConstants.SET_DISTANCE_UNIT:
      return { ...state, distanceUnit: action.distanceUnit }
    case IntubationConstants.SET_METHOD:
      return { ...state, method: action.method }
    case IntubationConstants.SET_SECURED_VIA:
      return { ...state, securedVia: action.securedVia }
    case IntubationConstants.SET_VERIFIED_BY:
      return { ...state, verifiedBy: action.verifiedBy }
    case IntubationConstants.SET_VERIFICATION_VIA:
      return { ...state, verificationVia: action.verificationVia }
    case IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE:
      return { ...state, airwayPlacementTechnique: action.airwayPlacementTechnique }
    case IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE_PNNV:
      return { ...state, airwayPlacementTechniquePNNV: action.airwayPlacementTechniquePNNV }
    case IntubationConstants.SET_RSI_PROTOCOL:
      return { ...state, rSIProtocol: action.rSIProtocol }
    case IntubationConstants.SET_MALLAMPATI:
      return { ...state, mallampati: action.mallampati }
    case IntubationConstants.SET_SELLICK_MANEUVER:
      return { ...state, sellickManeuver: action.sellickManeuver }
    case IntubationConstants.SET_LARYNGOSCOPIC_GRADE:
      return { ...state, laryngoscopicGrade: action.laryngoscopicGrade }
    case IntubationConstants.SET_STYLET_USED:
      return { ...state, styletUsed: action.styletUsed }
    case IntubationConstants.SET_CUFF_FILL:
      return { ...state, cuffFill: action.cuffFill }
    case IntubationConstants.SET_CUFF_FILL_QTY:
      return { ...state, cuffFillQty: action.cuffFillQty }
    case IntubationConstants.SET_LARYNGOSCOPE_BLADE:
      return { ...state, laryngoscopeBlade: action.laryngoscopeBlade }
    case IntubationConstants.SET_INDICATIONS:
      return { ...state, indications: action.indications }
    case IntubationConstants.SET_DECISION_TO_MANAGE_TIME:
      return { ...state, decisiontoManageTime: action.time }
    case IntubationConstants.SET_DECISION_TO_MANAGE_DATE:
      return { ...state, decisiontoManageDate: action.date }
    case IntubationConstants.SET_DECISION_TO_MANAGE_DATE_TIME:
      return { ...state, decisiontoManageTime: action.time, decisiontoManageDate: action.date }
    case IntubationConstants.SET_ABANDONED_TIME:
      return { ...state, abandonedTime: action.time }
    case IntubationConstants.SET_ABANDONED_DATE:
      return { ...state, abandonedDate: action.date }
    case IntubationConstants.SET_ABANDONED_DATE_TIME:
      return { ...state, abandonedTime: action.time, abandonedDate: action.date }
    case IntubationConstants.SET_AIRWAY_COMPLICATIONS:
      return { ...state, airwayComplications: action.airwayComplications }
    case IntubationConstants.SET_AIRWAY_COMPLICATIONS_PNNV:
      return { ...state, airwayComplicationsPNNV: action.airwayComplicationsPNNV }
    case IntubationConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case IntubationConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case IntubationConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case IntubationConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case IntubationConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case IntubationConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case IntubationConstants.SET_STATE:
      return { ...state, ...action.intubationState, updateInputRows: true }
    case IntubationConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case IntubationConstants.SET_INTUBATION_DEFAULTS:
      return { ...state, intubationDefaults: action.intubationDefaults }
    case IntubationConstants.SET_REASONS_FOR_FAILURE:
      return { ...state, reasonsForFailure: action.reasonsForFailure }
    case IntubationConstants.RESET_STATE:
      return {
        key: randomNumber().toString(),
        date: '',
        time: '',
        assessedBy: null,
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        size: '',
        distance: '',
        distanceUnit: null,
        method: null,
        securedVia: null,
        verifiedBy: null,
        verificationVia: [],
        airwayPlacementTechnique: [],
        airwayPlacementTechniquePNNV: null,
        rSIProtocol: null,
        mallampati: null,
        sellickManeuver: null,
        laryngoscopicGrade: null,
        styletUsed: null,
        cuffFill: null,
        cuffFillQty: '',
        laryngoscopeBlade: null,
        indications: [],
        decisiontoManageTime: '',
        decisiontoManageDate: '',
        decisiontoManageDateTime: '',
        abandonedTime: '',
        abandonedDate: '',
        abandonedDateTime: '',
        airwayComplications: [],
        airwayComplicationsPNNV: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        type: 'Intubation',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        intubationDefaults: null,
        reasonsForFailure: [],
        nemsisCode: null,
      }
    default:
      return state
  }
}
